module.exports = __webpack_public_path__ + "de2c6fbcd192243fea54675f7bf24ddd.svg";